import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';



/**
 * UserDAO
 * 認証系DAO
 */
export class DiagnoseDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}


	// 検査結果のリストを取得
	public async getDiagnoseList() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.USER_DIAGNOSE_LIST_GET, request);
		return ret;

	}


	// 検査結果の詳細取得
	public async getDiagnoseDetail(file_info_id: any) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			file_info_id
		};

		const ret = await this.postRequest(AppSettingApi.USER_DIAGNOSE_DETAIL_GET, request);
		return ret;

	}


}
